import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class MultiplierOreView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_multore');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedBonus = new BigNum(0);
        /**
         * @type {string}
         */
        this.displayedValue = null;

        /**
         * @type {HTMLElement}
         */
        this.body = null;


        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        // <span id="mineDamageDisplay" class="mine-damage-display"></span>

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // mult
        ////////////////////////////////////

        const baseMultiDiv = Page.createElement('div', parentElement, null, 'mine-damage-panel-main-section');
        const baseMultiHeader = Page.createElement('div', baseMultiDiv, null, 'mine-damage-panel-section-header');
        baseMultiHeader.innerHTML = 'Ore Multi';

        this.body = Page.createElement('div', baseMultiDiv, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const oreDamageMultiplier = this.damage.oreDamageMultiplier;

        /////////////////////////////////////
        // Base Multiplicative Bonus
        /////////////////////////////////////
        
        if (!this.displayedValue || !oreDamageMultiplier.equals(this.displayedBonus)) {
            this.displayedBonus.copy(oreDamageMultiplier);
            
            this.displayedValue = NumberFormatter.formatBigNum(oreDamageMultiplier);
    
            this.body.innerHTML = this.displayedValue;
        }

        super.updateViewContents();
    }

}